import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React, { useState } from 'react';
import { constants } from '../../constants';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { utility } from '../../utility';

/**
 * NewsManagement List Table Component
 */
const NewsManagementListTable = ({ controlSettings, messageList, newsManagedPage, iconControlList, setModalInfo }) => {

  const [currentHoverNewsId, setCurrentHoverNewsId] = useState(null);

  return (
    <Box sx={{ height: 730, border: '1px solid rgb(224, 224, 224)' }}>
      {/* データ無し時：データ無しメッセージ / データ有り時：News一覧 */}
      {newsManagedPage.ItemList.length === 0
        ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0059}</MyMLabel>
        :
        <TableContainer sx={{ height: '100%' }}>
          <Table>
            <TableBody sx={{
              'tr > td': { paddingTop: 1 },
              'tr:nth-of-type(2n) > td': { paddingBottom: 1 },
              'tr:nth-of-type(2n-1) > td': { paddingBottom: 0 },
            }} >
              {newsManagedPage.ItemList.map((news) => (
                <React.Fragment key={news.NewsId}>
                  <NewsManagementListTableRow isHover={news.NewsId === currentHoverNewsId} setCurrentHoverNewsId={setCurrentHoverNewsId} setModalInfo={setModalInfo} news={news}>
                    <TableCell className='border-bottom-0' scope='row' width='65%'>
                      <MyMLabel fontWeight='bold'>{news.Title}</MyMLabel>
                    </TableCell>
                    <TableCell className='border-bottom-0' scope='row' width='25%'>
                      <MyMLabel>{controlSettings.LabelList[news.NewsType === constants.NewsType.GlobalNews ? 'lblGlobalSiteNews' : 'lblInternalNews']}</MyMLabel></TableCell>
                    <TableCell className='pt-0' rowSpan={2} scope='row' width='5%'>
                      {news.HasExpiredLink === true && iconControlList.linkError.control('large')}
                    </TableCell>
                    <TableCell className='pt-0' rowSpan={2} scope='row' width='5%'>
                      {news.PublishType === constants.PublishType.Unpublish ? iconControlList.unPublished.control('large') : iconControlList.published.control('large')}
                    </TableCell>
                  </NewsManagementListTableRow>
                  <NewsManagementListTableRow isHover={news.NewsId === currentHoverNewsId} setCurrentHoverNewsId={setCurrentHoverNewsId} setModalInfo={setModalInfo} news={news}>
                    <TableCell><MyMLabel>{controlSettings.LabelList.lblNewsUpdateDateTitle}{utility.formatDate(news.UpdateDate)}</MyMLabel></TableCell>
                    <TableCell>
                      <MyMLabel>
                        {news.PublishType === constants.PublishType.Unpublish ? '' : controlSettings.LabelList.lblNewsPublishDateTitle}
                        {news.PublishType === constants.PublishType.Unpublish ? '':utility.formatDate(news.PublishDate)}
                      </MyMLabel>
                    </TableCell>
                  </NewsManagementListTableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </Box>
  );
}
export default NewsManagementListTable;

/**
 * NewsManagement List Table Row Component
 */
const NewsManagementListTableRow = React.memo(({ isHover, setCurrentHoverNewsId, setModalInfo, news, children }) => {
  return (
    <TableRow
      onMouseEnter={() => setCurrentHoverNewsId(news.NewsId)}
      onMouseLeave={() => setCurrentHoverNewsId(null)}
      sx={{ backgroundColor: isHover && 'rgba(0, 0, 0, 0.04)' }}
      // 2024.5.8 MyMine Version1.5対応 Add Start
      onDoubleClick={() => setModalInfo({ isOpen: true, newsType: news.NewsType, newsId: news.NewsId })}
    // 2024.5.8 MyMine Version1.5対応 Add End
    >
      {children}
    </TableRow>
  );
})
